export const PROVIDER_COVER_GENIUS = 'cover_genius';
export const PROVIDER_NIB = 'nib';
export const PROVIDER_PASSPORT_CARD = 'passport_card';
export const INSURANCE_TYPE_PASSPORT_CARD = 'passport-card-insurance';
export const INSURANCE_TYPE_CFMR = 'cfmr';
// Agent-facing label for PassportCard policies. Their raw product code
// (PASSPORT_CARD_COMPREHENSIVE_TRAVEL_INSURANCE) is unreadable in list columns, and the
// provider's own product_name is localised per region, so admin shows this fixed label.
export const PASSPORT_CARD_INSURANCE_LABEL = 'PassportCard Insurance';
export const PASSPORT_CARD_PORTAL_URL = 'https://partner.passportcard.com.au';
export const CUSTOM_AMOUNT_COVERAGE_MULTIPLIER = 1.7;
// Highest cancellation level PassportCard offers on its quotes
export const PASSPORT_CARD_MAX_COVERAGE_AMOUNT = 120000;
// Cap XCover applies to custom cancellation coverage amounts
export const COVER_GENIUS_MAX_COVERAGE_AMOUNT = 20000;
// After this date, XCover doesn't use the multiplier anymore
export const COVERAGE_MULTIPLIER_LIMIT_DATE = '2025-06-10T23:59:59.999Z';
